export enum DisplaySummaryMode {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}
